import { List } from "immutable";
import { withId, withoutId } from "@utils/domain";
import { contentStateFromString, contentStateToString } from "@utils/richText/converters";
import { Diploma } from "./diploma";
import { Track, TrackDraft } from "./track";

export interface TrackDraftDto extends Omit<TrackDraft, "description" | "levels"> {
	description: string;
	levels: {
		title: string;
		diplomas: DiplomaDto[];
	}[];
}

export interface TrackDto extends TrackDraftDto {
	id: string;
}

export interface DiplomaDto extends Omit<Diploma, "description" | "id"> {
	description: string;
}

export function trackDraftToDto(draft: TrackDraft): TrackDraftDto {
	return {
		...draft,
		description: contentStateToString(draft.description),
		levels: draft.levels
			.map(({ title, diplomas }) => ({ title, diplomas: diplomas.map(diplomaToDto).toArray() }))
			.toArray(),
	};
}
function diplomaToDto(dto: Diploma): DiplomaDto {
	return withoutId({ ...dto, description: contentStateToString(dto.description) });
}

export function trackFromDto(dto: TrackDto): Track {
	return {
		...dto,
		description: contentStateFromString(dto.description),
		levels: List(
			dto.levels.map(({ title, diplomas }) => withId({ title, diplomas: List(diplomas.map(diplomaFromDto)) }))
		),
	};
}
function diplomaFromDto(dto: DiplomaDto): Diploma {
	return withId({ ...dto, description: contentStateFromString(dto.description) });
}
